module.exports = __webpack_public_path__ + "cc2d9685926c1074edf809eec2329a27.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Bold.woff
// module id = 387
// module chunks = 0